import React from "react";

const PayrollHeader = ({
  setSort,
  sort,
}: {
  setSort: (column: string, order: string) => void;
  sort: { column: string; order: string };
}) => {
  return (
    <thead className="text-center">
      <tr className="text-uppercase">
        <th
          colSpan={14}
          className="align-middle"
          style={{
            background: "linear-gradient(90deg, #50B7C0 10%, #36cfc9 90%)",
            color: "white",
            border: "none",
            position: "sticky",
            top: 0,
            zIndex: 10,
            padding: "0.6rem 0.5rem",
            fontSize: "0.75rem",
            fontWeight: 600,
            letterSpacing: "0.05em",
          }}
        >
          Percepciones
        </th>
        <th
          colSpan={2}
          className="align-middle"
          style={{
            background: "linear-gradient(90deg, #f43f5e 0%, #e11d48 100%)",
            color: "white",
            border: "none",
            position: "sticky",
            top: 0,
            zIndex: 10,
            padding: "0.6rem 0.5rem",
            fontSize: "0.75rem",
            fontWeight: 600,
            letterSpacing: "0.05em",
          }}
        >
          Deducciones
        </th>
        <th
          colSpan={1}
          className="align-middle"
          style={{
            background: "linear-gradient(90deg, #0ea5e9 0%, #0891b2 100%)",
            color: "white",
            border: "none",
            position: "sticky",
            top: 0,
            zIndex: 10,
            padding: "0.6rem 0.5rem",
            fontSize: "0.75rem",
            fontWeight: 600,
            letterSpacing: "0.05em",
          }}
        >
          Otros
        </th>
        <th
          colSpan={2}
          className="align-middle"
          style={{
            background: "linear-gradient(90deg, #eab308 0%, #f59e0b 100%)",
            color: "white",
            border: "none",
            position: "sticky",
            top: 0,
            zIndex: 10,
            padding: "0.6rem 0.5rem",
            fontSize: "0.75rem",
            fontWeight: 600,
            letterSpacing: "0.05em",
          }}
        >
          Final
        </th>
      </tr>

      <tr>
        {titles.map((title, index) => {
          // Casos especiales de división
          const getLines = (text: string): string[] => {
            const specialCases: { [key: string]: string[] } = {
              "Sueldo base 15": ["Sueldo", "base 15"],
              "Salario diario": ["Salario", "diario"],
              "Pago por hora": ["Pago", "por hora"],
              "Días laborados": ["Días", "laborados"],
              "Jornadas completadas": ["Jornadas", "completadas"],
              "Horas trabajadas": ["Horas", "trabajadas"],
              "Horas normales": ["Horas", "normales"],
              "Turnos dobles": ["Turnos", "dobles"],
              "Horas extras": ["Horas", "extras"],
              "Descanso trabajado": ["Descanso", "trabajado"],
              "Descanso disfrutado": ["Descanso", "disfrutado"],
              "Días festivos": ["Días", "festivos"],
              Tarjetas: ["Tarjetas"],
              "Total de deducciones": ["Total", "deducciones"],
              "Pago estimado": ["Pago", "estimado"],
            };
            return specialCases[text] || [text];
          };

          const lines = getLines(title);
          const hasMultipleLines = lines.length > 1;

          return (
            <th
              key={index}
              className="align-middle"
              style={{
                background: "#f8fafc",
                borderLeft: "none",
                borderRight: "none",
                borderTop: "none",
                borderBottom: "2px solid #e2e8f0",
                position: "sticky",
                top: "32px",
                zIndex: 9,
                padding: "0.4rem 0.3rem",
                fontSize: "0.65rem",
                fontWeight: 600,
                color: "#475569",
                cursor: "pointer",
                whiteSpace: "nowrap",
                transition: "background 0.2s ease",
                lineHeight: 1.2,
              }}
              onClick={() =>
                setSort(title, sort.order === "asc" ? "desc" : "asc")
              }
              onMouseEnter={(e) => {
                e.currentTarget.style.background = "#e2e8f0";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.background = "#f8fafc";
              }}
            >
              <div className="d-flex flex-column align-items-center justify-content-center">
                {lines.map((line, i) => (
                  <span key={i}>{line}</span>
                ))}
                {title === sort.column && (
                  <i
                    className={`fa-solid fa-sort-${
                      sort.order === "asc" ? "up" : "down"
                    } mt-1`}
                    style={{ fontSize: "0.55rem" }}
                  ></i>
                )}
              </div>
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

/** Mismas columnas que la tabla del cuadro de mando (export Excel, etc.). */
export const PAYROLL_CUADRO_COLUMN_LABELS: string[] = [
  "Chilito",
  "Sueldo base 15",
  "Salario diario",
  "Pago por hora",
  "Días laborados",
  "Jornadas completadas",
  "Horas trabajadas",
  "Horas normales",
  "Turnos dobles",
  "Horas extras",
  "Descanso trabajado",
  "Descanso disfrutado",
  "Días festivos",
  "Bonos",
  "Total de deducciones",
  "Tarjetas",
  "Incidencias",
  "Detalles",
  "Pago estimado",
];

export default PayrollHeader;

const titles = PAYROLL_CUADRO_COLUMN_LABELS;
